import React from 'react'
import "./Footer.scss";


const Footer = () => {
    return (
        <footer>
            <div className="wrapper">
                <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank" rel="noopener noreferrer">מדיניות פרטיות</a>
                <span>|</span>
                <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank" rel="noopener noreferrer">תנאי שימוש</a>
            </div>
        </footer>
    )
}

export default Footer
